import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

// Registering the required Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const GroupedStackedBarChart = () => {
  // Sample data for the chart representing 7 days of the week
  const data = {
    labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'], // Days of the week
    datasets: [
      {
        label: 'Completed',
        data: [50, 70, 80, 60, 90, 40, 30], // Completed projects data for each day
        backgroundColor: '#3152F4', // Solid Blue for Completed
        stack: 'stack1', // Grouped in stack
        borderRadius: 8, // Rounded corners for bars
      },
      {
        label: 'Pending',
        data: [20, 30, 40, 25, 10, 35, 45], // Pending projects data for each day
        backgroundColor: '#9ebefa', // Solid Red for Pending
        stack: 'stack1', // Grouped in stack
        borderRadius: 8, // Rounded corners for bars
      },
    ],
  };

  // Chart options for customizing the chart
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: 'Project Status: Completed vs Pending (7 Days)',
        font: {
          size: 20,
          family: 'Arial, sans-serif',
          weight: 'bold',
        },
        color: '#333', // Dark color for the title
        padding: { bottom: 20 },
      },
      legend: {
        position: 'top',
        labels: {
          font: {
            size: 14,
            family: 'Arial, sans-serif',
          },
          color: '#555',
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false, // Remove grid lines for a cleaner look
        },
        ticks: {
          font: {
            size: 12,
            family: 'Arial, sans-serif',
          },
          color: '#333',
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: {
          color: 'rgba(0, 0, 0, 0.1)', // Lighter grid lines
        },
        ticks: {
          font: {
            size: 12,
            family: 'Arial, sans-serif',
          },
          color: '#333',
        },
      },
    },
  };

  return (
    <div style={{ width: '100%', height: '500px', padding: '20px', borderRadius: '10px', marginTop: '30px', backgroundColor: '#f5f5f5' }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default GroupedStackedBarChart;
